import type React from 'react';
import { useCallback } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
import './ServiceLayout.css';
import './EverfieldEnergy.css';



export default function EverfieldEnergy(): React.JSX.Element {
  const onIntersect = useCallback((entry: IntersectionObserverEntry) => {
    entry.target.classList.add('ee-content--visible');
  }, []);
  const contentRef = useIntersectionObserver<HTMLElement>(onIntersect, { threshold: 0.1 });

  return (
    <div className="service-page">
      <Navbar />

      {/* ── Hero ── */}
      <section
        className="service-page__hero ee-hero"
        aria-labelledby="ee-heading"
        style={{ '--service-bg': 'url(/Everfield.webp)' } as React.CSSProperties}
      >
        <div className="service-page__overlay" />
        <div className="service-page__content">
          <p className="service-page__label">Our Services</p>
          <h1 id="ee-heading" className="service-page__heading">Everfield Energy</h1>
        </div>
      </section>

      {/* ── Content ── */}
      <section className="ee-content" aria-labelledby="ee-content-heading" ref={contentRef}>
        <h2 id="ee-content-heading" className="ee-content__heading">
          Generation · Storage · Trading
        </h2>
        <p className="ee-content__body">
          Develops, owns, and operates the energy infrastructure layer of the Everfield Group
          platform —strategically selected Hybrid Energy Hub sites plus a distinct distressed
          solar acquisition sub-strategy. Long-term PPAs are available to Everfield DC,
          third-party DC operators, and other large energy users seeking guaranteed green power.
        </p>

      </section>

      <Footer />
    </div>
  );
}
